import './IconDDAPlay.css';
import React from 'react';
const IconDDAPlay = _ref => {
  let {
    width = 48,
    height = 48,
    className = ''
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: `${className} ${styles}`,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 10V38L35 24L13 10Z"
  }));
};
const styles = "ss9wo5e";
export default IconDDAPlay;